import React from 'react';
import { Link } from 'wouter';
import { Activity } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-green-dark text-white shadow-lg overflow-hidden mt-auto">
      <div className="relative z-10">
        <div className="container mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0">
            {/* Esquerda: Logo + Copyright */}
            <div className="flex items-center space-x-3">
              <Link to="/" className="flex items-center space-x-2">
                <img 
                  src="/Logo_2.png" 
                  alt="FotUP Logo" 
                  className="h-12 w-auto"
                />
                <div className="flex flex-col">
                  <span className="text-lg font-bold text-white leading-tight">FotUP</span>
                  <span className="text-xs text-white/70 leading-tight">Fotografia Esportiva</span>
                </div>
              </Link>
              <span className="text-white/80 text-sm">
                © 2025 FotUP. Todos os direitos reservados.
              </span>
            </div>

            {/* Centro: Links */}
            <div className="flex flex-wrap items-center space-x-4 text-sm">
              <Link to="/" className="text-white/80 hover:text-white transition-colors">
                Home
              </Link>
              <span className="text-white/50">|</span>
              <Link to="/contact" className="text-white/80 hover:text-white transition-colors">
                Contato
              </Link>
              <span className="text-white/50">|</span>
              <Link to="/terms" className="text-white/80 hover:text-white transition-colors">
                Termos
              </Link>
              <span className="text-white/50">|</span>
              <Link to="/privacy" className="text-white/80 hover:text-white transition-colors">
                Política
              </Link>
            </div>

            {/* Direita: Powered by + System Status */}
            <div className="flex items-center space-x-4">
              <span className="text-white/70 text-sm">
                Powered by Devonno Soluções Digitais
              </span>
              <Link
                to="/system-status"
                className="flex items-center space-x-2 bg-orange-500/20 hover:bg-orange-500/30 px-3 py-1 rounded transition-colors"
              >
                <Activity className="h-4 w-4 text-green-500" />
                <span className="text-green-500 text-sm font-medium">System Status</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}